import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
// Vendors
import Keycloak from 'keycloak-js';
import cookies from "../cookies/cookies";
import session from "../session/session.utils";
// Constants
import constants from "./constants/usd.constants";
// Core
import setupUsdCore from "./core/usd.core";
// Types

var keycloak;
var initKeycloak = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, new Promise(function (resolve, reject) {
            var _window$location, _window$location$host;
            keycloak = Keycloak(constants.KEYCLOAK_CONFIG);
            var currentDomain = (_window$location = window.location) !== null && _window$location !== void 0 && (_window$location$host = _window$location.hostname) !== null && _window$location$host !== void 0 && _window$location$host.includes('localhost') ? '' : '.zinia.com';
            keycloak.init({
              onLoad: 'login-required',
              checkLoginIframe: false
            }).then(function (authenticated) {
              authenticated && cookies.setCookie({
                name: 'agentToken',
                value: keycloak.token,
                domain: currentDomain
              });
              window.setAgentClientData(generateFakeUsdInit());
            })["catch"](function () {
              return reject();
            });
          }));
      }
    }, _callee);
  }));
  return function initKeycloak() {
    return _ref.apply(this, arguments);
  };
}();
var isLocalDevelopment = function isLocalDevelopment() {
  return new RegExp(/localhost/).test(window.location.hostname);
};
export var generateFakeUsdInit = function generateFakeUsdInit() {
  window.console.log('CC fake init called');
  var createInteractionId = function createInteractionId() {
    var letters = '0123456789abcdef';
    var interactionId = '';
    for (var i = 0; i < 16; i++) {
      interactionId += letters[Math.floor(Math.random() * 16)];
    }
    return interactionId;
  };
  return {
    agentToken: cookies.getCookie('agentToken'),
    country: 'NL',
    email: 'customeremail@gmail.com',
    documentType: 'phone',
    interactionId: '8be3cc9e83a0227c',
    platform: 'CC',
    securitySSR_AccessToken: '',
    securitySSR_RefreshToken: '',
    sessionId: createInteractionId(),
    firstName: 'Antonio',
    lastName: 'Resines',
    userName: 'customeremail@gmail.com',
    /**
     * USD communicates UI USD raises N1
     * @constructor
     */
    AssistedAuthenticateSuccess: function AssistedAuthenticateSuccess() {
      window.console.log('Assisted success authentication');
      window.location.replace('/overview');
    },
    GetAgentAccessToken: function GetAgentAccessToken() {
      window.console.log('Renew agent access token');
      Keycloak(constants.KEYCLOAK_CONFIG).updateToken().then(function () {
        return window.USD.refreshAgentToken(keycloak.token);
      })["catch"](function () {
        session.clearSessionData();
      });
    },
    OnLogoutSuccess: function OnLogoutSuccess() {
      window.location.href = '/assisted-login';
    },
    OnInvalidSession: function OnInvalidSession() {
      window.location.href = '/assisted-login';
    },
    RaiseN2InIvr: function RaiseN2InIvr() {},
    SignatureKeyExpired: function SignatureKeyExpired() {}
  };
};
var setUSDCommunicationMethods = function setUSDCommunicationMethods(callback) {
  window.setAgentClientData = function (usdInformation) {
    if (!isLocalDevelopment()) {
      // We need to ensure to clear each time loads to remove all data storaged
      session.clearSessionData();
    }
    window.USD.init(usdInformation);
    callback && callback();
  };
  window.refreshAgentToken = function (agentToken) {
    window.USD.refreshAgentToken(agentToken);
  };
  window.notifyAgentToken = function () {
    return null;
  }; // Alejandro pending

  window.invalidateSessionTokens = function () {};
  window.refreshSessionTokens = function (accessToken, refreshToken) {
    return {
      accessToken: accessToken,
      refreshToken: refreshToken
    };
  };
  window.notifyInteractionEnded = function () {};
  window.RaiseN2InIvrSuccess = function () {};
  window.RaiseN2InIvrFailure = function (errorType) {
    return {
      errorType: errorType
    };
  };
  window.updateSignatureKeySuccess = function () {};
  window.updateSignatureKeyFailure = function (errorType) {
    return {
      errorType: errorType
    };
  };
};
var setupUSDInit = function setupUSDInit(callback) {
  setupUsdCore();
  setUSDCommunicationMethods(callback);
  if (isLocalDevelopment()) {
    window.setAgentClientData(generateFakeUsdInit());
  }
};
var usd = {
  setupUSDInit: setupUSDInit,
  initKeycloak: initKeycloak,
  core: function core() {
    return window.USD;
  }
};
export default usd;